// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__1OAwt","itemTitle":"ClientEmergencyInfo_itemTitle__dA6Il","itemText":"ClientEmergencyInfo_itemText__1otxt"};